import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

const CountdownWrapper = styled.strong`
    padding-left: 4px;
`;
export interface ICountdown {
    totalSeconds: number;
    onElapsed(): void;
}
export const Countdown = observer(({ totalSeconds, onElapsed }: ICountdown) => {
    const [seconds, setSeconds] = React.useState<number>(totalSeconds);
    const [isVisible, setIsVisible] = React.useState(true);
    const displaySeconds = seconds % 60;
    const displayMinutes = Math.floor(seconds / 60);
    let timeout: NodeJS.Timeout;
    React.useEffect(() => {
        if (seconds > 0) {
            timeout = setTimeout(() => {
                setSeconds((state) => state - 1);
            }, 1000);
        } else {
            onElapsed();
            setIsVisible(false);
            clearTimeout(timeout);
        }

        return () => clearTimeout(timeout);
    }, [seconds, onElapsed]);

    if (!seconds) {
        return null;
    }

    return isVisible ? (
        <CountdownWrapper>
            {String(displayMinutes).padStart(2, '0')}:{String(displaySeconds).padStart(2, '0')}
        </CountdownWrapper>
    ) : null;
});
